export const routePaths = {
  list: '/list',
  wip: '/wip',
  wipParticipant: '/wipParticipant',
  newProgramParticipant: '/programParticipant',
};
